// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Index from "./auth/Index";
// import Login from "./auth/login";
// import Register from "./auth/register";
// import TaskToolbar from "./task/TaskToolbar";
// import TaskBoard from "./task/TaskBoard";
// import AddTaskForm from "./task/AddTaskForm";
// import { useState } from "react";
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// // import NotFound from "./pages/NotFound";


// const App = () => {
//   const [showForm, setShowForm] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');

//   const [tasks, setTasks] = useState(() => {
//     const saved = localStorage.getItem("tasks");
//     return saved ? JSON.parse(saved) : {
//       new: [],
//       pending: [],
//       inProgress: [],
//       completed: [],
//     };
//   });

//   const handleAddTask = (newTask) => {
//     const updated = {
//       ...tasks,
//       [newTask.category]: [newTask, ...tasks[newTask.category]],
//     };
//     setTasks(updated);
//     localStorage.setItem("tasks", JSON.stringify(updated));
//   };

//   // const allTasks = Object.values(tasks).flat(); // Combine toutes les tâches
//   // const filteredTasks = allTasks.filter((task) =>
//   //   task.title.toLowerCase().includes(searchTerm.toLowerCase())
//   // );

//   const allTasks = Object.entries(tasks).reduce((acc, [category, list]) => {
//     acc[category] = list.filter((task) =>
//       task.title.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//     return acc;
//   }, {});
//   const handleSearch = (value) => {
//     setSearchTerm(value);
//   };

//   return (
//     <BrowserRouter>
//       <TaskToolbar onShowForm={() => setShowForm(true)} onSearch={handleSearch} />{showForm && (
//         <AddTaskForm
//           onClose={() => setShowForm(false)}
//           onAddTask={handleAddTask}
//         />
//       )}

//       <Routes>
//         <Route path="/" element={<Index />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/register" element={<Register />} />
//         <Route
//           path="/home"
//           element={
//             <TaskBoard
//               tasks={searchTerm ? allTasks : tasks}
//               setTasks={setTasks}
//             />
//           }
//         />

//         <Route path="/task/create" element={<AddTaskForm />} />
//         {/* <Route path="*" element={<NotFound />} /> */}
//       </Routes>
//       <ToastContainer position="top-right" autoClose={3000} />

//     </BrowserRouter>
//   );

// };

// export default App;

// src/App.js
// import React, { useState } from 'react';
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   useNavigate,
// } from 'react-router-dom';
// import Navbar from './admin/Navbar';
// import Sidebar from './admin/Sidebar';
// import OrganizationsList from './admin/OrganizationsList';
// import CreateOrganization from './admin/CreateOrganization';
// import EmployeesList from './admin/EmployeesList';
// import AddEmployee from './admin/AddEmployee';
// import EmployeeDetail from './admin/EmployeeDetail';

// const initialOrgs = [
//   { id: 1, name: 'DevCorp', description: 'Leading software development firm.' },
//   { id: 2, name: 'InnovaTech', description: 'Innovative solutions for modern businesses.' },
//   { id: 3, name: 'SoftGroup', description: 'Your partner in digital transformation.' },
// ];

// // Données d'exemple pour les employés globalement
// const initialEmps = [
//   { id: 1, nom: 'Doe', prenom: 'John', email: 'john.doe@example.com', role: 'developpeur', telephone: '0612345678', cin: 'A123456', date_naissance: '1990-01-01', sexe: 'M', adresse: '123 Rue Exemple', date_embauche: '2020-06-01', rib: 'FR76...', type_contrat: 'CDI' },
//   { id: 2, nom: 'Smith', prenom: 'Jane', email: 'jane.smith@example.com', role: 'chef_projet', telephone: '0698765432', cin: 'B654321', date_naissance: '1985-05-10', sexe: 'F', adresse: '456 Avenue Modèle', date_embauche: '2018-03-15', rib: 'FR45...', type_contrat: 'CDD' },
//   // ... autres employés
// ];

// function OrganisationsPage() {
//   const [searchQuery, setSearchQuery] = useState('');
//   const [filter, setFilter] = useState('');
//   const navigate = useNavigate();

//   const filteredOrgs = initialOrgs.filter(
//     (org) =>
//       org.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
//       (filter === '' || org.name === filter)
//   );

//   return (
//     <div>
//       <Navbar
//         searchQuery={searchQuery}
//         onSearchChange={setSearchQuery}
//         filter={filter}
//         onFilterChange={setFilter}
//         onCreate={() => navigate('/organisations/create')}
//       />
//       <OrganizationsList organizations={filteredOrgs} />
//     </div>
//   );
// }

// function EmployeesPage() {
//   return <EmployeesList employees={initialEmps} />;
// }

// function App() {
//   const [collapsed, setCollapsed] = useState(false);

//   return (
//     <Router>
//       <div className="flex h-screen">
//         <Sidebar onCollapseChange={setCollapsed} />
//         <main
//           style={{ marginLeft: collapsed ? '80px' : '256px' }}
//           className="overflow-auto transition-all duration-300 bg-gray-50 p-6 flex-1"
//         >
//           <Routes>
//             <Route path="/organisations" element={<OrganisationsPage />} />
//             <Route path="/organisations/create" element={<CreateOrganization />} />
//             <Route path="/employees" element={<EmployeesPage />} />
//             <Route path="/employees/:empId" element={<EmployeeDetail employees={initialEmps} />} />
//             <Route path="/add-employee" element={<AddEmployee addEmployee={AddEmployee} />} />
//             {/* autres routes */}
//           </Routes>
//         </main>
//       </div>
//     </Router>
//   );
// }

// export default App;

// // // src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import VisitorRoutes from './routes/VisitorRoutes';
import AdminRoutes from './routes/AdminRoutes';
import AdminclientRoutes from './routes/AdminclientRoutes';
import ClientRoutes from './routes/ClientRoutes';
import TechniqueRoutes from './routes/TechniqueRoutes';
import ChefProjetRoutes from './routes/ChefProjetRoutes';
import FileUpload from './image';
import FonctionelRoutes from './routes/FonctionelRoutes';
import DgRoutes from './routes/DgRoutes';
import Login from './auth/login';
import Register from './auth/register';
import ProtectedRoute from './auth/ProtectedRoute';
import Unauthorized from './pages/Unauthorized';


// function App() {
//   const [role, setRole] = useState('client');

//   return (
//     <>
//       <Routes>
//       <Route path="/login" element={<Login />} />
//       <Route path="/" element={<Navigate to="/login" />} />
//       <Route path="/register" element={<Register />} />
//       <Route path="/unauthorized" element={<Login />} />
//         {/* Routes spécifiques aux rôles */}
//         <Route
//   path="/admin/*"
//   element={
//     <ProtectedRoute allowedRoles={[2]}>
//       <AdminRoutes />
//     </ProtectedRoute>
//   }
// />

// <Route
//   path="/admin-client/*"
//   element={
//     <ProtectedRoute allowedRoles={[6]}>
//       <AdminclientRoutes />
//     </ProtectedRoute>
//   }
// />

// <Route
//   path="/client/*"
//   element={
//     <ProtectedRoute allowedRoles={[1]}>
//       <ClientRoutes />
//     </ProtectedRoute>
//   }
// />

// <Route
//   path="/Technique/*"
//   element={
//     <ProtectedRoute allowedRoles={[4]}>
//       <TechniqueRoutes />
//     </ProtectedRoute>
//   }
// />

// <Route
//   path="/ChefProjet/*"
//   element={
//     <ProtectedRoute allowedRoles={[3]}>
//       <ChefProjetRoutes />
//     </ProtectedRoute>
//   }
// />

// <Route
//   path="/fonctionelle/*"
//   element={
//     <ProtectedRoute allowedRoles={[5]}>
//       <FonctionelRoutes />
//     </ProtectedRoute>
//   }
// />

// <Route
//   path="/dg/*"
//   element={
//     <ProtectedRoute allowedRoles={[8]}>
//       <DgRoutes />
//     </ProtectedRoute>
//   }
// />

//         <Route path="/marouane" element={<FileUpload /> } />


//         {/* Page 404 si aucune route ne correspond */}
//         <Route path="*" element={<h1>Page non trouvée</h1>} />
//       </Routes>
//        <ToastContainer position="top-right" autoClose={500} closeOnClick={false}    draggable={false}  pauseOnHover={false}   /> 
//        </>   
//   );
// }

// export default App;


function App() {
  const [role, setRole] = useState('client');

  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/register" element={<Register />} />
        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* Routes protégées */}
        <Route path="/admin/*" element={<ProtectedRoute allowedRoles={[2]}><AdminRoutes /></ProtectedRoute>} />
        <Route path="/admin-client/*" element={<ProtectedRoute allowedRoles={[6]}><AdminclientRoutes /></ProtectedRoute>} />
        <Route path="/client/*" element={<ProtectedRoute allowedRoles={[1]}><ClientRoutes /></ProtectedRoute>} />
        <Route path="/Technique/*" element={<ProtectedRoute allowedRoles={[4]}><TechniqueRoutes /></ProtectedRoute>} />
        <Route path="/ChefProjet/*" element={<ProtectedRoute allowedRoles={[3]}><ChefProjetRoutes /></ProtectedRoute>} />
        <Route path="/fonctionelle/*" element={<ProtectedRoute allowedRoles={[5]}><FonctionelRoutes /></ProtectedRoute>} />
        <Route path="/dg/*" element={<ProtectedRoute allowedRoles={[8]}><DgRoutes /></ProtectedRoute>} />

        <Route path="/marouane" element={<FileUpload />} />
        <Route path="*" element={<h1>Page non trouvée</h1>} />
      </Routes>
      <ToastContainer position="top-right" autoClose={500} />
    </>
  );
}


export default App;
